var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7544 84.6867C71.6893 82.0615 87.3429 62.1517 84.7177 40.2168C82.0925 18.2819 62.1827 2.62835 40.2478 5.25353C18.313 7.87871 2.65938 27.7885 5.28455 49.7234C7.90973 71.6583 27.8196 87.3119 49.7544 84.6867Z",
    fill: "#ECB13A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0989 81.36C68.7999 78.8824 83.573 60.0925 81.0955 39.3915C78.618 18.6905 59.8281 3.91742 39.127 6.39493C18.426 8.87244 3.65295 27.6624 6.13046 48.3634C8.60797 69.0644 27.3979 83.8375 48.0989 81.36Z",
    fill: "#FFDE4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8994 62.9909C35.3699 64.2511 25.9484 58.2815 24.9197 49.6866C24.8343 48.973 25.3369 48.3306 26.0471 48.2456C26.7573 48.1606 27.3972 48.6662 27.4826 49.3799C28.3423 56.563 36.4667 61.5076 45.5912 60.4156C54.7157 59.3235 61.4419 52.5859 60.584 45.4183C60.4986 44.7046 61.0012 44.0622 61.7114 43.9772C62.4216 43.8922 63.0615 44.3979 63.1469 45.1116C64.1756 53.7065 56.4288 61.7308 45.8994 62.9909Z",
    fill: "#645033"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5573 38.1132C29.5733 37.7522 31.7257 35.0146 31.3647 31.9986C31.0037 28.9826 28.2661 26.8302 25.2501 27.1911C22.234 27.5521 20.0817 30.2897 20.4426 33.3058C20.8036 36.3218 23.5412 38.4742 26.5573 38.1132Z",
    fill: "#645033"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8103 34.0137C63.8264 33.6528 65.992 31.0263 65.6475 28.1473C65.3029 25.2684 62.5786 23.2272 59.5626 23.5881C56.5465 23.9491 54.3809 26.5756 54.7254 29.4545C55.07 32.3335 57.7943 34.3747 60.8103 34.0137Z",
    fill: "#645033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.a1f4b8b968db4bb1c11a478c6e9b846f.svg";
export { ForwardRef as ReactComponent };